// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_survey-question-header__\\+Jt\\+e {
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 223px;
  gap: 58px;
  padding: 0 32px;
}

.styles_survey-question-title__FeWTP label:first-child {
  color: #1264e0 !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
}

.styles_survey-question-title__FeWTP input {
  border-bottom-color: #000000;
  font-weight: 700;
  font-size: 18px;
}

.styles_survey-question-options-container__jm86L {
  display: grid;
  /* grid-template-columns: 1fr 223px; */
  gap: 58px;
  margin-top: 40px;
  padding: 0 32px;
}

.styles_survey-question-option-item__b\\+mny {
  margin-bottom: 16px !important;
  width: 100%;
}

.styles_survey-question-option-item__b\\+mny input {
  border-color: #b6c2e2 !important;
  border-radius: 6px !important;
}

.styles_survey-question-option-container__WqMc5 {
  display: grid;
  grid-template-columns: 1fr 32px;
}

.styles_add-new-option-btn__uliQX {
}

.styles_add-new-option-btn__uliQX button {
  display: "flex" !important;
  align-items: "center" !important;
  justify-content: "center" !important;
  gap: 6px !important;
  height: 35px !important;
}

/* .survey-question-block:hover .survey-question-footer-actions {
  height: 56px;
  border-top: 1px solid #707070;
} */

.styles_survey-question-footer-actions__VnDYw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding: 0 32px;
  height: 56px;
  border-top: 1px solid #707070;
  /* transition: all 0.2s ease-in;
  height: 0;
  overflow: hidden; */
}

.styles_add-question-btn__P\\+h2G {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  gap: 8px;
}

.styles_survey-question-calification-container__y61gi {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_question-actions-list__acqW4 {
  display: flex;
  align-items: center;
  gap: 16px;
}

.styles_question-action-switch__M-yoE {
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_survey-question-calification-list__sqB9n {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
}

.styles_calification-item__lL5wh {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.styles_survey-calification-conditionals__q0jSP {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_survey-condition-item__m0XhD {
  display: grid;
  grid-template-columns: 200px 338px;
  align-items: center;
}

.styles_survey-question-calification-filters__HEkgn {
  display: flex;
  align-items: center;
  gap: 16px;
}

.styles_options-without-conditionals__PxP6p,
.styles_options-without-conditionals--btn__XquxJ {
  display: grid;
  grid-template-columns: 1fr 223px;
}

.styles_options-with-conditionals__BQ2Tj,
.styles_options-with-conditionals--btn__R7Yns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 76px;
}

.styles_options-without-conditionals--btn__XquxJ {
  width: calc(100% - 32px);
}

.styles_options-with-conditionals--btn__R7Yns {
  width: calc(100% - 62px);
}

.styles_conditional-label__JTqAa{
  position: absolute;
  top: 60%;
  left: -30px;
  z-index: 10;
  transform: translateY(-50%);
}

/* .options-content{
  width: 50%;
} */
`, "",{"version":3,"sources":["webpack://./src/components/QuestionBlock/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;AACA;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B;;qBAEmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;GAEG","sourcesContent":[".survey-question-header {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: 1fr 223px;\n  gap: 58px;\n  padding: 0 32px;\n}\n\n.survey-question-title label:first-child {\n  color: #1264e0 !important;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 100%;\n}\n\n.survey-question-title input {\n  border-bottom-color: #000000;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.survey-question-options-container {\n  display: grid;\n  /* grid-template-columns: 1fr 223px; */\n  gap: 58px;\n  margin-top: 40px;\n  padding: 0 32px;\n}\n\n.survey-question-option-item {\n  margin-bottom: 16px !important;\n  width: 100%;\n}\n\n.survey-question-option-item input {\n  border-color: #b6c2e2 !important;\n  border-radius: 6px !important;\n}\n\n.survey-question-option-container {\n  display: grid;\n  grid-template-columns: 1fr 32px;\n}\n\n.add-new-option-btn {\n}\n\n.add-new-option-btn button {\n  display: \"flex\" !important;\n  align-items: \"center\" !important;\n  justify-content: \"center\" !important;\n  gap: 6px !important;\n  height: 35px !important;\n}\n\n/* .survey-question-block:hover .survey-question-footer-actions {\n  height: 56px;\n  border-top: 1px solid #707070;\n} */\n\n.survey-question-footer-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 32px;\n  padding: 0 32px;\n  height: 56px;\n  border-top: 1px solid #707070;\n  /* transition: all 0.2s ease-in;\n  height: 0;\n  overflow: hidden; */\n}\n\n.add-question-btn {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n  gap: 8px;\n}\n\n.survey-question-calification-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.question-actions-list {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.question-action-switch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.survey-question-calification-list {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 16px;\n}\n\n.calification-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.survey-calification-conditionals {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.survey-condition-item {\n  display: grid;\n  grid-template-columns: 200px 338px;\n  align-items: center;\n}\n\n.survey-question-calification-filters {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.options-without-conditionals,\n.options-without-conditionals--btn {\n  display: grid;\n  grid-template-columns: 1fr 223px;\n}\n\n.options-with-conditionals,\n.options-with-conditionals--btn {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 76px;\n}\n\n.options-without-conditionals--btn {\n  width: calc(100% - 32px);\n}\n\n.options-with-conditionals--btn {\n  width: calc(100% - 62px);\n}\n\n.conditional-label{\n  position: absolute;\n  top: 60%;\n  left: -30px;\n  z-index: 10;\n  transform: translateY(-50%);\n}\n\n/* .options-content{\n  width: 50%;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"survey-question-header": `styles_survey-question-header__+Jt+e`,
	"survey-question-title": `styles_survey-question-title__FeWTP`,
	"survey-question-options-container": `styles_survey-question-options-container__jm86L`,
	"survey-question-option-item": `styles_survey-question-option-item__b+mny`,
	"survey-question-option-container": `styles_survey-question-option-container__WqMc5`,
	"add-new-option-btn": `styles_add-new-option-btn__uliQX`,
	"survey-question-footer-actions": `styles_survey-question-footer-actions__VnDYw`,
	"add-question-btn": `styles_add-question-btn__P+h2G`,
	"survey-question-calification-container": `styles_survey-question-calification-container__y61gi`,
	"question-actions-list": `styles_question-actions-list__acqW4`,
	"question-action-switch": `styles_question-action-switch__M-yoE`,
	"survey-question-calification-list": `styles_survey-question-calification-list__sqB9n`,
	"calification-item": `styles_calification-item__lL5wh`,
	"survey-calification-conditionals": `styles_survey-calification-conditionals__q0jSP`,
	"survey-condition-item": `styles_survey-condition-item__m0XhD`,
	"survey-question-calification-filters": `styles_survey-question-calification-filters__HEkgn`,
	"options-without-conditionals": `styles_options-without-conditionals__PxP6p`,
	"options-without-conditionals--btn": `styles_options-without-conditionals--btn__XquxJ`,
	"options-with-conditionals": `styles_options-with-conditionals__BQ2Tj`,
	"options-with-conditionals--btn": `styles_options-with-conditionals--btn__R7Yns`,
	"conditional-label": `styles_conditional-label__JTqAa`
};
export default ___CSS_LOADER_EXPORT___;
